import React, { useCallback } from 'react';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { selectPhysicalDemandById } from 'store/entities/configuration/configurationSelectors';
import { ModalDialog } from 'shared/components/modals/ModalDialog';
import { setEditPhysicalDemandsTemplateId, updatePhysicalDemandsTemplate } from 'modules/settings/submodules/clients/physicalDemands/store/action';
import { selectEditPhysicalDemandsTemplateId, selectIsPhysicalDemandsTemplateUpdating } from 'modules/settings/submodules/clients/physicalDemands/store/selectors';
import TemplateFormWrapper
    from 'modules/settings/submodules/clients/components/PhysicalDemandsAndWorkingConditions/AddTemplate/Modal/TemplateFormWrapper';
import { ITemplateFormValues } from 'modules/settings/submodules/clients/components/PhysicalDemandsAndWorkingConditions/AddTemplate/Modal/models';
import { useColoredFormModalStyles } from 'shared/components/modals/ModalStyles';

export default function EditPhysicalDemandsModal() {
    const dispatch = useDispatch();
    const id = useSelector(selectEditPhysicalDemandsTemplateId);
    const template = useSelector(selectPhysicalDemandById(id));
    const isLoading = useSelector(selectIsPhysicalDemandsTemplateUpdating);

    const onSave = useCallback((data: ITemplateFormValues) => {
        dispatch(updatePhysicalDemandsTemplate.init({
            id,
            data,
        }));
    }, [dispatch, id]);

    const classes = useColoredFormModalStyles();
    const onClose = useCallback(() => {
        dispatch(setEditPhysicalDemandsTemplateId(null));
    }, [dispatch]);
    return (
        <ModalDialog
            title="Edit Physical Demand Template"
            isOpened={Boolean(id)}
            onClose={onClose}
            modalProps={{
                customClasses: classes,
                showCloseIcon: true,
            }}
        >
            <Box>
                <TemplateFormWrapper
                    onSubmit={onSave}
                    submitTitle="Update"
                    templateLabel="Physical Demands"
                    isLoading={isLoading}
                    template={template}
                />
            </Box>
        </ModalDialog>
    );
}
